import classNames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { bannerMessages } from './messages';
import style from './style.module.css';
import { HelpArticleLink } from '../../components/help-article-link';
import { linkIDs } from '../../services/link-service/links';

export const DutiesAndTaxesBanner = ({ className = null }) => (
  <BannerMessageV2
    className={classNames(className, style['duties-and-taxes-banner'])}
    content={
      <>
        <h5 className={style['duties-and-taxes-banner__title']}>
          <FormattedMessage {...bannerMessages.title} />
        </h5>
        <p className={style['duties-and-taxes-banner__message']}>
          <FormattedMessage
            {...bannerMessages.message}
            values={{
              a: (chunks) => <HelpArticleLink articleId={linkIDs.InternationalDutiesBilling}>{chunks}</HelpArticleLink>,
            }}
          />
        </p>
      </>
    }
    status={BannerStatus.Info}
  />
);

DutiesAndTaxesBanner.propTypes = {
  className: PropTypes.string,
};
